import React from "react";
import { CCol, CContainer, CRow } from "@coreui/react-pro";
import PublicSiteShell from "./PublicSiteShell";

export default function PublicAuthLayout({
  activeAuthPath,
  eyebrow,
  title,
  description,
  benefits,
  rightPane,
  headerMode = "auth",
  shellPreset = "",
  pageClassName = "",
  benefitColumnProps = { xs: 12, md: 6 },
}) {
  const resolvedPageClassName = ["public-auth-page", pageClassName].filter(Boolean).join(" ");

  const hero = (
    <section className="public-auth-hero">
      <CContainer fluid className="public-core-container public-page-shell public-auth-shell">
        <div className="public-auth-hero__panel public-page-hero-panel">
          <div className="public-auth-hero__copy">
            <div className="public-auth-copy__head">
              <span className="public-core-eyebrow public-page-overline">{eyebrow}</span>
              <h1 className="public-page-title public-auth-hero__title">{title}</h1>
              <p className="public-page-body public-auth-hero__lead">{description}</p>
            </div>

            <CRow className="g-3 public-core-auth-benefits-grid">
              {benefits.map((benefit) => (
                <CCol {...benefitColumnProps} key={benefit.title}>
                  <article className="public-page-value-card public-core-auth-benefit public-core-auth-benefit--light">
                    <span className="public-core-auth-benefit__label">{benefit.label}</span>
                    <h3>{benefit.title}</h3>
                    <p>{benefit.text}</p>
                  </article>
                </CCol>
              ))}
            </CRow>
          </div>

          <div className="public-auth-hero__form">
            {rightPane}
          </div>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicSiteShell
      mode={headerMode}
      activeAuthPath={activeAuthPath}
      pageClassName={resolvedPageClassName}
      topBandTone="light"
      shellPreset={shellPreset}
      hero={hero}
    />
  );
}
